import type { GapsSummary } from '../../types';

interface GapCriteriaTableProps {
  criteria: GapsSummary['top_criteria'];
}

export function GapCriteriaTable({ criteria }: GapCriteriaTableProps) {
  if (criteria.length === 0) {
    return <p className="text-wolf-500 text-sm">No criteria data available</p>;
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-wolf-300">Top Problem Criteria</h3>
      <div className="bg-wolf-800 rounded-lg border border-wolf-700 overflow-hidden">
        <table className="w-full">
          <thead className="bg-wolf-900">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-wolf-400 uppercase">
                Criterion
              </th>
              <th className="px-4 py-2 text-right text-xs font-medium text-wolf-400 uppercase">
                Count
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-wolf-700">
            {criteria.map((criterion) => (
              <tr key={criterion.id} className="hover:bg-wolf-700/30">
                <td className="px-4 py-2 text-sm text-white">
                  {criterion.name}
                </td>
                <td className="px-4 py-2 text-sm text-right font-mono text-action">
                  {criterion.count}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
